// extracted by mini-css-extract-plugin
export default {"controlButtonPrev":"Modal_controlButtonPrev__tAR5a","controlButtonNext":"Modal_controlButtonNext__JBcxk","controlButtonDisabled":"Modal_controlButtonDisabled__bpl9D"};